import { deleteField, doc, getDoc,updateDoc } from 'firebase/firestore';

import { db } from '@src/firebase/firebase';
import Chart from '@src/models/Chart';
import { ACTIONS } from '@src/util/firebase-operations/constants';
import {
  getRouteToChartByDivision,
  getRouteToChartByOrg,
} from '@src/util/firebase-operations/constants';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class ChartRepository {
  constructor() {
    this.chart = new Chart();
  }

  getCollectionPath(orgId, divId = null, boardId) {
    if (divId) {
      return getRouteToChartByDivision(orgId, divId, boardId);
    }
    return getRouteToChartByOrg(orgId, boardId);
  }

  async create({ data, orgId, divId = null, boardId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.chart.setData(data);
      const res = await createOperation(collectionPath, null, this.chart, ACTIONS.CREATE);
      return res;
    }).catch(error => {
      throw error;
    });
  }

  async update({ data, orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      const chartRef = doc(db, collectionPath, chartId);
      
      this.chart.setData(data);
      const chartData = this.chart.toUpdate();
      
      // If aggregations exists, delete it first to replace completely
      if (chartData.aggregations !== undefined) {
        await updateDoc(chartRef, {
          aggregations: deleteField(),
        });
      }
      
      await createOperation(collectionPath, chartId, chartData, ACTIONS.UPDATE);
      return chartData;
    }).catch(error => {
      throw error;
    });
  }

  async get({ orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      const chartRef = doc(db, collectionPath, chartId);
      const chartDoc = await getDoc(chartRef);
      
      if (chartDoc.exists()) {
        return { id: chartDoc.id, ...chartDoc.data() };
      }
      return null;
    }).catch(error => {
      throw error;
    });
  }
}

export default ChartRepository;
